module.exports = "/_next/static/images/credit-1-934e3f900406c9d1dd7b1733f1328165.png";